/* Melanina for Shopify — storefront behaviour ported from the React source.
   Hero procession, edit filters, arrivals + collection carousels, campaign shorts,
   predictive search, variant picker, and the native AJAX cart drawer. */
(function () {
  "use strict";

  var root = document.documentElement;
  var body = document.body;
  var routes = {
    root: body.getAttribute("data-root-url") || "/",
    cart: body.getAttribute("data-cart-url") || "/cart",
    cartAdd: body.getAttribute("data-cart-add-url") || "/cart/add",
    cartChange: body.getAttribute("data-cart-change-url") || "/cart/change",
    cartUpdate: body.getAttribute("data-cart-update-url") || "/cart/update",
    predictive: body.getAttribute("data-predictive-search-url") || "/search/suggest",
    search: body.getAttribute("data-search-url") || "/search"
  };
  var strings = {
    added: body.getAttribute("data-string-added") || "está no seu saco.",
    saved: body.getAttribute("data-string-saved") || "foi guardado para mais tarde.",
    error: body.getAttribute("data-string-error") || "Algo correu mal. Tente novamente.",
    videoLoading: body.getAttribute("data-string-video") || "Este vídeo de moda ainda está a carregar. Tente novamente dentro de instantes."
  };

  function reduceMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function on(type, selector, handler) {
    document.addEventListener(type, function (event) {
      var target = event.target instanceof Element ? event.target.closest(selector) : null;
      if (target) handler(event, target);
    });
  }

  /* ------------------------------------------------------------------ toast */
  var toastTimer = null;

  function toast(message) {
    var host = $("[data-toast]");
    if (!host || !message) return;
    host.textContent = message;
    host.hidden = false;
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      host.hidden = true;
      host.textContent = "";
    }, 2800);
  }

  /* ------------------------------------------------------ focus management */
  var lastFocused = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    lastFocused = document.activeElement;
    var initial = $$(FOCUSABLE, container);
    if (initial.length) initial[0].focus();
    container.__melaninaTrap = function (event) {
      if (event.key !== "Tab") return;
      /* queried on each keypress so the trap survives section re-rendering */
      var focusable = $$(FOCUSABLE, container);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    container.addEventListener("keydown", container.__melaninaTrap);
  }

  function releaseFocus(container) {
    if (container && container.__melaninaTrap) {
      container.removeEventListener("keydown", container.__melaninaTrap);
      delete container.__melaninaTrap;
    }
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    lastFocused = null;
  }

  /* ------------------------------------------------------------ mobile nav */
  on("click", "[data-menu-toggle]", function (event, toggle) {
    var nav = $("[data-nav]");
    if (!nav) return;
    var open = nav.classList.toggle("open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.classList.toggle("is-open", open);
  });

  on("click", "[data-nav] a", function () {
    var nav = $("[data-nav]");
    var toggle = $("[data-menu-toggle]");
    if (nav) nav.classList.remove("open");
    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.classList.remove("is-open");
    }
  });

  /* --------------------------------------------------------- cart drawer */
  function openDrawer() {
    var drawer = $("[data-cart-drawer]");
    var scrim = $("[data-cart-scrim]");
    if (!drawer) return;
    drawer.hidden = false;
    if (scrim) scrim.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    root.style.overflow = "hidden";
    trapFocus(drawer);
  }

  function closeDrawer() {
    var drawer = $("[data-cart-drawer]");
    var scrim = $("[data-cart-scrim]");
    if (!drawer || drawer.hidden) return;
    releaseFocus(drawer);
    drawer.hidden = true;
    drawer.setAttribute("aria-hidden", "true");
    if (scrim) scrim.hidden = true;
    root.style.overflow = "";
  }

  on("click", "[data-cart-open]", function (event) {
    event.preventDefault();
    openDrawer();
  });
  on("click", "[data-cart-close]", function (event) {
    event.preventDefault();
    closeDrawer();
  });

  function setBusy(state) {
    var drawer = $("[data-cart-drawer]");
    if (drawer) drawer.classList.toggle("is-busy", !!state);
  }

  function syncCartCount() {
    var source = $("[data-cart-total-count]");
    if (!source) return;
    var count = source.getAttribute("data-cart-total-count") || source.textContent.trim();
    $$("[data-cart-count]").forEach(function (node) {
      node.textContent = count;
    });
  }

  function replaceSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var markup = sections[key];
      if (typeof markup !== "string") return;
      var current = document.getElementById("shopify-section-" + key) || document.querySelector("[data-section-id='" + key + "']");
      if (!current) return;
      var holder = document.createElement("div");
      holder.innerHTML = markup;
      var incoming = holder.querySelector("#shopify-section-" + key) || holder.querySelector("[data-section-id='" + key + "']") || holder;
      current.innerHTML = incoming.innerHTML;
    });
    syncCartCount();
  }

  function cartRequest(url, payload) {
    payload.sections = payload.sections || "cart-drawer";
    payload.sections_url = window.location.pathname;
    return fetch(url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || strings.error);
        return data;
      });
    });
  }

  function addToCart(variantId, quantity, properties, label) {
    var payload = { items: [{ id: Number(variantId), quantity: quantity || 1 }] };
    if (properties) payload.items[0].properties = properties;
    setBusy(true);
    return cartRequest(routes.cartAdd, payload)
      .then(function (data) {
        replaceSections(data.sections);
        if (body.getAttribute("data-open-drawer-on-add") !== "false") openDrawer();
        if (label) toast(label + " " + strings.added);
        document.dispatchEvent(new CustomEvent("melanina:cart:updated"));
      })
      .catch(function (error) {
        toast(error.message || strings.error);
      })
      .then(function () {
        setBusy(false);
      });
  }

  function changeLine(line, quantity, extraSections) {
    var active = document.activeElement;
    var focusKey = active && active.getAttribute ? active.getAttribute("data-focus-key") : null;
    setBusy(true);
    return cartRequest(routes.cartChange, {
      line: Number(line),
      quantity: Number(quantity),
      sections: extraSections ? "cart-drawer," + extraSections : "cart-drawer"
    })
      .then(function (data) {
        replaceSections(data.sections);
        if (focusKey) {
          var restored = document.querySelector('[data-focus-key="' + focusKey + '"]');
          if (restored && !restored.disabled) restored.focus();
        }
        document.dispatchEvent(new CustomEvent("melanina:cart:updated"));
      })
      .catch(function (error) {
        toast(error.message || strings.error);
      })
      .then(function () {
        setBusy(false);
      });
  }

  /* add-to-cart forms (cards, product page, quick add) */
  on("submit", "form[data-cart-form]", function (event, form) {
    event.preventDefault();
    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) {
      toast(strings.error);
      return;
    }
    var quantityField = form.querySelector('[name="quantity"]');
    var quantity = quantityField ? parseInt(quantityField.value, 10) || 1 : 1;
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute("aria-busy", "true");
    addToCart(idField.value, quantity, null, form.getAttribute("data-product-title")).then(function () {
      if (button) button.removeAttribute("aria-busy");
    });
  });

  /* drawer + cart page line controls */
  on("click", "[data-line-change]", function (event, button) {
    event.preventDefault();
    if (button.disabled) return;
    var line = button.getAttribute("data-line");
    var quantity = button.getAttribute("data-quantity");
    changeLine(line, quantity, button.getAttribute("data-extra-sections"));
  });

  on("change", "input[data-line-quantity]", function (event, input) {
    changeLine(input.getAttribute("data-line"), input.value, input.getAttribute("data-extra-sections"));
  });

  /* ------------------------------------------------------- search overlay */
  var predictiveTimer = null;

  function openSearch() {
    var overlay = $("[data-search-overlay]");
    if (!overlay) return;
    overlay.hidden = false;
    root.style.overflow = "hidden";
    trapFocus(overlay);
    var input = overlay.querySelector('input[name="q"]');
    if (input) input.focus();
  }

  function closeSearch() {
    var overlay = $("[data-search-overlay]");
    if (!overlay || overlay.hidden) return;
    releaseFocus(overlay);
    overlay.hidden = true;
    root.style.overflow = "";
  }

  on("click", "[data-search-open]", function (event) {
    event.preventDefault();
    openSearch();
  });
  on("click", "[data-search-close]", function (event) {
    event.preventDefault();
    closeSearch();
  });

  on("input", "[data-predictive-input]", function (event, input) {
    var results = $("[data-predictive-results]");
    if (!results) return;
    var term = input.value.trim();
    if (predictiveTimer) window.clearTimeout(predictiveTimer);
    if (term.length < 2) {
      results.innerHTML = "";
      return;
    }
    predictiveTimer = window.setTimeout(function () {
      var url =
        routes.predictive +
        "?q=" +
        encodeURIComponent(term) +
        "&resources[type]=product&resources[limit]=5&section_id=predictive-search";
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (markup) {
          var holder = document.createElement("div");
          holder.innerHTML = markup;
          var incoming = holder.querySelector("[data-predictive-list]");
          results.innerHTML = incoming ? incoming.innerHTML : "";
        })
        .catch(function () {
          results.innerHTML = "";
        });
    }, 240);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    closeSearch();
    closeDrawer();
  });

  /* ----------------------------------------------------------- hero slides */
  function initHero(section) {
    var slides = $$("[data-hero-slide]", section);
    var dots = $$("[data-hero-dot]", section);
    var copies = $$("[data-hero-copy]", section);
    if (slides.length < 1) return;
    var index = 0;
    var timer = null;
    var delay = parseInt(section.getAttribute("data-autoplay-speed"), 10) || 6200;

    function render() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle("active", i === index);
        slide.setAttribute("aria-hidden", i === index ? "false" : "true");
      });
      copies.forEach(function (copy, i) {
        copy.hidden = i !== index;
        if (i === index) {
          copy.style.animation = "none";
          void copy.offsetWidth;
          copy.style.animation = "";
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle("active", active);
        dot.setAttribute("aria-selected", active ? "true" : "false");
        dot.innerHTML = "";
        if (active && !reduceMotion()) dot.appendChild(document.createElement("i"));
      });
    }

    function go(next) {
      index = (next + slides.length) % slides.length;
      render();
      start();
    }

    function start() {
      stop();
      if (slides.length < 2 || reduceMotion() || section.getAttribute("data-autoplay") === "false") return;
      timer = window.setInterval(function () {
        go(index + 1);
      }, delay);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    section.addEventListener("click", function (event) {
      var dot = event.target.closest("[data-hero-dot]");
      if (dot) {
        go(dots.indexOf(dot));
        return;
      }
      var nav = event.target.closest("[data-hero-nav]");
      if (nav) go(index + (nav.getAttribute("data-hero-nav") === "next" ? 1 : -1));
    });
    section.addEventListener("mouseenter", stop);
    section.addEventListener("mouseleave", start);
    section.addEventListener("focusin", stop);

    render();
    start();
  }

  /* ------------------------------------------------------------ edit filter */
  function initShopFilters(section) {
    var tabs = $$('[data-edit-tab]', section);
    var cards = $$('[data-product-card]', section);
    var panels = $$('[data-edit-panel]', section);
    var empty = $('[data-edit-empty]', section);
    var hasCollectionPanels = panels.some(function (panel) {
      return (panel.getAttribute('data-edit-panel') || '').toLowerCase() !== 'all';
    });
    if (!tabs.length || !cards.length) return;

    function apply(value) {
      if (hasCollectionPanels && value.indexOf('collection-') === 0) {
        var visiblePanel = null;
        panels.forEach(function (panel) {
          var match = (panel.getAttribute('data-edit-panel') || '').toLowerCase() === value;
          panel.hidden = !match;
          if (match) visiblePanel = panel;
        });
        if (empty) empty.hidden = !visiblePanel || $$('[data-product-card]', visiblePanel).length !== 0;
        return;
      }

      if (panels.length) {
        panels.forEach(function (panel) {
          panel.hidden = (panel.getAttribute('data-edit-panel') || '').toLowerCase() !== 'all';
        });
        cards = $$('[data-product-card]', $('[data-edit-panel="all"]', section) || section);
      }

      var visible = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute("data-tags") || "").toLowerCase();
        var match = value === "all" || tags.split("|").indexOf(value) !== -1;
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    }

    section.addEventListener("click", function (event) {
      var tab = event.target.closest("[data-edit-tab]");
      if (!tab) return;
      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle("active", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
      });
      apply((tab.getAttribute("data-edit-tab") || "all").toLowerCase());
    });
  }

  /* ------------------------------------------------ group carousels (rails) */
  function initGroupCarousel(section, options) {
    var groupSelector = options.groupSelector;
    var groups = $$(groupSelector, section);
    if (groups.length < 1) return;
    var dots = $$("[data-group-dot]", section);
    var status = $("[data-group-status]", section);
    var loader = $("[data-group-loader]", section);
    var stage = $("[data-group-stage]", section) || section;
    var index = parseInt(section.getAttribute("data-start-index"), 10) || 0;
    if (index >= groups.length) index = 0;
    var timer = null;
    var paused = false;
    var busy = false;
    var delay = parseInt(section.getAttribute("data-autoplay-speed"), 10) || 6700;

    function render() {
      groups.forEach(function (group, i) {
        if (i === index) {
          var fresh = group.cloneNode(true);
          fresh.hidden = false;
          group.replaceWith(fresh);
          groups[i] = fresh;
        } else {
          group.hidden = true;
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle("active", active);
        dot.setAttribute("aria-selected", active ? "true" : "false");
      });
      if (status) {
        var label = groups[index].getAttribute("data-group-label") || "";
        status.innerHTML =
          "<span>" +
          String(index + 1).padStart(2, "0") +
          "</span> / " +
          String(groups.length).padStart(2, "0") +
          (label ? " &middot; " + label : "");
      }
    }

    function commit(next) {
      var target = (next + groups.length) % groups.length;
      if (target === index) return;
      if (options.loaderDelay && loader && !reduceMotion()) {
        if (busy) return;
        busy = true;
        stage.classList.add("is-loading");
        loader.hidden = false;
        var pending = loader.querySelector("[data-group-loader-label]");
        if (pending) pending.textContent = groups[target].getAttribute("data-group-label") || "";
        window.setTimeout(function () {
          index = target;
          render();
          stage.classList.remove("is-loading");
          loader.hidden = true;
          busy = false;
        }, options.loaderDelay);
      } else {
        index = target;
        render();
      }
    }

    function start() {
      stop();
      if (groups.length < 2 || paused || reduceMotion() || section.getAttribute("data-autoplay") === "false") return;
      timer = window.setInterval(function () {
        commit(index + 1);
      }, delay);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    section.addEventListener("click", function (event) {
      var dot = event.target.closest("[data-group-dot]");
      if (dot) {
        commit(dots.indexOf(dot));
        start();
        return;
      }
      var nav = event.target.closest("[data-group-nav]");
      if (nav) {
        commit(index + (nav.getAttribute("data-group-nav") === "next" ? 1 : -1));
        start();
      }
    });
    section.addEventListener("mouseenter", function () {
      paused = true;
      stop();
    });
    section.addEventListener("mouseleave", function () {
      paused = false;
      start();
    });
    section.addEventListener("focusin", function () {
      paused = true;
      stop();
    });
    section.addEventListener("focusout", function (event) {
      if (section.contains(event.relatedTarget)) return;
      paused = false;
      start();
    });

    render();
    start();
  }

  /* --------------------------------------------------------- campaign shorts */
  function initVideoStories(section) {
    var grid = $("[data-stories]", section);
    if (!grid) return;
    var notes = $$("[data-story]", grid);
    if (!notes.length) return;
    var active = null;
    var started = false;

    function videoFor(note) {
      return note.querySelector("video");
    }

    function setProgress(note, ratio) {
      var bar = note.querySelector("[data-story-progress]");
      if (bar) bar.style.setProperty("--note-progress", Math.round(ratio * 100) + "%");
    }

    function stopAll(except) {
      notes.forEach(function (note, i) {
        if (i === except) return;
        var video = videoFor(note);
        if (video) {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (error) {
            /* seeking before metadata is fine to ignore */
          }
        }
        note.classList.remove("is-playing");
        note.setAttribute("aria-pressed", "false");
      });
    }

    function play(i) {
      var note = notes[i];
      if (!note) return;
      var video = videoFor(note);
      if (!video) return;
      if (active === i) {
        video.pause();
        note.classList.remove("is-playing");
        note.setAttribute("aria-pressed", "false");
        grid.classList.remove("is-playing");
        active = null;
        return;
      }
      stopAll(i);
      setProgress(note, 0);
      try {
        video.currentTime = 0;
      } catch (error) {
        /* ignore */
      }
      var attempt = video.play();
      if (attempt && typeof attempt.then === "function") {
        attempt
          .then(function () {
            active = i;
            note.classList.add("is-playing");
            note.setAttribute("aria-pressed", "true");
            grid.classList.add("is-playing");
          })
          .catch(function () {
            if (started) toast(strings.videoLoading);
          });
      } else {
        active = i;
        note.classList.add("is-playing");
        note.setAttribute("aria-pressed", "true");
        grid.classList.add("is-playing");
      }
    }

    notes.forEach(function (note, i) {
      var video = videoFor(note);
      note.addEventListener("click", function () {
        started = true;
        play(i);
      });
      if (!video) return;
      video.addEventListener("timeupdate", function () {
        setProgress(note, video.duration ? video.currentTime / video.duration : 0);
      });
      video.addEventListener("ended", function () {
        setProgress(note, 1);
        note.classList.remove("is-playing");
        note.setAttribute("aria-pressed", "false");
        grid.classList.remove("is-playing");
        active = null;
        if (reduceMotion()) return;
        window.setTimeout(function () {
          play((i + 1) % notes.length);
        }, 420);
      });
    });

    if (reduceMotion()) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || started) return;
          started = true;
          observer.disconnect();
          window.setTimeout(function () {
            play(0);
          }, 650);
        });
      },
      { threshold: 0.35 }
    );
    observer.observe(grid);
  }

  /* --------------------------------------------------------- product page */
  function initProduct(section) {
    var form = $("[data-product-form]", section);
    var dataNode = $("[data-variant-data]", section);
    if (!dataNode) return;
    var variants = [];
    try {
      variants = JSON.parse(dataNode.textContent) || [];
    } catch (error) {
      variants = [];
    }
    var idField = form ? form.querySelector('[name="id"]') : null;
    var submit = form ? form.querySelector('[type="submit"]') : null;
    var priceHost = $("[data-variant-price]", section);
    var compareHost = $("[data-variant-compare]", section);
    var saveHost = $("[data-variant-save]", section);
    var skuHost = $("[data-variant-sku]", section);
    var inventoryHost = $("[data-variant-inventory]", section);
    var optionInputs = $$("[data-option-index]", section);

    function selectedOptions() {
      var values = [];
      optionInputs.forEach(function (input) {
        if (input.tagName === "SELECT") {
          values[Number(input.getAttribute("data-option-index"))] = input.value;
        } else if (input.checked) {
          values[Number(input.getAttribute("data-option-index"))] = input.value;
        }
      });
      return values;
    }

    function matchVariant() {
      var chosen = selectedOptions();
      if (!chosen.length) return variants[0];
      for (var i = 0; i < variants.length; i += 1) {
        var variant = variants[i];
        var ok = true;
        for (var o = 0; o < chosen.length; o += 1) {
          if (chosen[o] !== undefined && variant.options[o] !== chosen[o]) {
            ok = false;
            break;
          }
        }
        if (ok) return variant;
      }
      return null;
    }

    /* Strike through option values that cannot be combined with the current selection. */
    function markUnavailableOptions() {
      var chosen = selectedOptions();
      $$("[data-option-value]", section).forEach(function (label) {
        var input = label.querySelector("input[data-option-index]");
        if (!input) return;
        var index = Number(input.getAttribute("data-option-index"));
        var candidate = chosen.slice();
        candidate[index] = input.value;
        var reachable = variants.some(function (variant) {
          if (!variant.available) return false;
          for (var i = 0; i < candidate.length; i += 1) {
            if (i === index) continue;
            if (candidate[i] !== undefined && variant.options[i] !== candidate[i]) return false;
          }
          return variant.options[index] === input.value;
        });
        label.classList.toggle("is-unavailable", !reachable);
      });
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var target = $('[data-media-id="' + mediaId + '"]', section);
      if (!target) return;
      target.scrollIntoView({ behavior: reduceMotion() ? "auto" : "smooth", block: "nearest" });
      $$("[data-media-thumb]", section).forEach(function (thumb) {
        thumb.setAttribute("aria-current", thumb.getAttribute("data-media-thumb") === String(mediaId) ? "true" : "false");
      });
    }

    function render() {
      markUnavailableOptions();
      var variant = matchVariant();
      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute("data-unavailable-label") || "Indisponível";
        }
        return;
      }
      if (idField) idField.value = variant.id;
      if (priceHost) priceHost.innerHTML = variant.price;
      if (compareHost) {
        compareHost.innerHTML = variant.compare_at_price || "";
        compareHost.hidden = !variant.compare_at_price;
      }
      if (saveHost) saveHost.hidden = !variant.compare_at_price;
      if (skuHost) {
        skuHost.textContent = variant.sku || "";
        skuHost.hidden = !variant.sku;
      }
      if (inventoryHost) {
        inventoryHost.hidden = !variant.inventory_label;
        inventoryHost.className = "m-inventory" + (variant.available ? (variant.inventory_low ? " is-low" : "") : " is-out");
        var text = inventoryHost.querySelector("span");
        if (text) text.textContent = variant.inventory_label || "";
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.getAttribute("data-add-label") || "Adicionar ao saco"
          : submit.getAttribute("data-sold-out-label") || "Esgotado";
      }
      showMedia(variant.featured_media_id);
      if (window.history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener("change", render);
    });

    $$("[data-media-thumb]", section).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        showMedia(thumb.getAttribute("data-media-thumb"));
      });
    });

    if (optionInputs.length) render();
  }

  /* ------------------------------------------------------- quantity steppers */
  on("click", "[data-quantity-step]", function (event, button) {
    event.preventDefault();
    var wrapper = button.closest("[data-quantity]");
    if (!wrapper) return;
    var input = wrapper.querySelector("input");
    if (!input) return;
    var step = button.getAttribute("data-quantity-step") === "up" ? 1 : -1;
    var min = parseInt(input.getAttribute("min"), 10);
    var next = (parseInt(input.value, 10) || 1) + step;
    if (isNaN(min)) min = 1;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ------------------------------------------------------- collection tools */
  on("change", "[data-auto-submit]", function (event, field) {
    var form = field.closest("form");
    if (form) form.submit();
  });

  /* ----------------------------------------------------------- save for later */
  on("click", "[data-save-note]", function (event, button) {
    event.preventDefault();
    toast((button.getAttribute("data-product-title") || "") + " " + strings.saved);
  });

  /* -------------------------------------------------------------- bootstrap */
  function bootstrap(scope) {
    $$("[data-melanina-hero]", scope).forEach(initHero);
    $$("[data-melanina-shop]", scope).forEach(initShopFilters);
    $$("[data-melanina-arrivals]", scope).forEach(function (section) {
      initGroupCarousel(section, { groupSelector: "[data-arrival-group]" });
    });
    $$("[data-melanina-commerce]", scope).forEach(function (section) {
      initGroupCarousel(section, { groupSelector: "[data-commerce-group]", loaderDelay: 440 });
    });
    $$("[data-melanina-stories]", scope).forEach(initVideoStories);
    $$("[data-melanina-product]", scope).forEach(initProduct);
    syncCartCount();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootstrap(document);
    });
  } else {
    bootstrap(document);
  }

  /* theme editor support */
  document.addEventListener("shopify:section:load", function (event) {
    bootstrap(event.target);
  });
  document.addEventListener("shopify:section:select", function (event) {
    if (event.target.querySelector("[data-cart-drawer]")) openDrawer();
  });

  window.Melanina = { openDrawer: openDrawer, closeDrawer: closeDrawer, addToCart: addToCart, toast: toast };
})();
